export default __webpack_public_path__ + "static/media/NationalWeb-Thin.0eaa29f9.eot";